import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import ReactNotification from 'react-notifications-component';
import NotFoundScene from 'scenes/NotFound';
import { isDevelopment } from 'helpers/isDevelopment';
import { Alert } from 'modules';
import FormWrapper from 'components/FormWrapper';
import { Routes as RoutesList } from 'routes/Routes';

const App = () => {
  const [condensed, setCondensed] = React.useState(false);

  const handleResize = (): void => {
    const { innerWidth: width /*, innerHeight: height*/ } = window;
    setCondensed(width >= 768 && width <= 991);
  };

  React.useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const classNames = ['body', 'with-subleft'];
  if (condensed) {
    classNames.push('collapsed-menu');
  }

  return (
    <div className={classNames.join(' ')}>
      {isDevelopment() && (
        <Alert type="danger" canClose={false} className="m-3">
          Jedná se o testovací verzi aplikace
          <br />
          POZOR: Je stále napojena na produkční databázi!
        </Alert>
      )}
      <ReactNotification />
      <Routes>
        <Route path={RoutesList.formDetail} element={<FormWrapper />} />
        <Route path={RoutesList.formAboutUs} element={<FormWrapper />} />
        <Route path={RoutesList.formAgreement} element={<FormWrapper />} />
        <Route path={RoutesList.formQuestions} element={<FormWrapper />} />
        <Route path={RoutesList.formPayment} element={<FormWrapper />} />
        <Route path={RoutesList.formSummary} element={<FormWrapper />} />
        <Route path={RoutesList.formTransmitReport} element={<FormWrapper />} />
        <Route path={RoutesList.formRejected} element={<FormWrapper />} />
        <Route path={RoutesList.formStarter} element={<FormWrapper />} />
        <Route path={RoutesList.formUploadIdentityCard} element={<FormWrapper />} />
        <Route path={'*'} element={<NotFoundScene />} />
      </Routes>
    </div>
  );
};

export default App;
